var Project = function (src) {
    var self = this;
    src = src || {};
    self.ProjectId = src.ProjectId || 0;
    self.ProjectTitle = src.ProjectTitle || '';
    self.ProjectSubTitle = src.ProjectSubTitle || '';
    self.Agency = src.Agency || '';
    self.PartnerOrganization = src.PartnerOrganization || '';
    self.PartnerOrganizationId = src.PartnerOrganizationId || 0;
    self.ProjectSiteLocation = src.ProjectSiteLocation || '';
    self.Justice40 = src.Justice40 || '';
    self.State = src.State || '';
    self.SpiWCS = src.SpiWCS || '';
    self.SpiPFS = src.SpiPFS || '';
    self.SpiCWPP = src.SpiCWPP || '';
    self.SpiGAOA = src.SpiGAOA || '';
    self.SpiJCP = src.SpiJCP || '';
    self.SpiCFLRP = src.SpiCFLRP || '';
    self.SpiNA = src.SpiNA || '';
    self.ProgramPartnerId = src.ProgramPartnerId || 0;
    self.ProgramPartner = src.ProgramPartner || '';
    self.Region = src.Region || '';
    self.ProjectState = src.ProjectState || '';
    self.ProjectDescription = src.ProjectDescription || '';
    self.WUI = src.WUI || 0;
    self.ForestDistrict = src.ForestDistrict || '';
    self.ForestName = src.ForestName || '';
    self.ProjectResourceOrderNo = src.ProjectResourceOrderNo || '';
    self.AssignmentType = src.AssignmentType || '';
    self.HazardType = src.HazardType || '';
    self.Acres = src.Acres || 0;
    self.Active = src.Active || 1;
    self.Deleted = src.Deleted || 0;
    self.Creator = src.Creator || '';
    self.LastModifiedBy = src.LastModifiedBy || '';
    self.CreatedDate = src.CreatedDate || new Date();
    self.CreatedDateString = src.CreatedDateString || '';
    self.CreatedBy = src.CreatedBy || '';
    self.LastUpdated = src.LastUpdated || new Date();
    self.LastUpdatedString = src.LastUpdatedString || '';
    self.LastUpdatedBy = src.LastUpdatedBy || '';
    self.UpdatingApp = src.UpdatingApp || '';
    self.Students = src.Students || [];
    return self;
};
angular.module('jcsfApp').value('Project', Project);